import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  showPrompt,
  hidePrompt,
} from '@store/defaultLandingPage/actions';
import * as createActions from '@store/dashboards/create/actions';
import * as updateActions from '@store/dashboards/update/actions';

import { selector as commonSelector } from '@store/common';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { selectors as dashboardsUIStoreSelector } from '@store/dashboards/ui';
import { selector as defaultLandingPageStore } from '@store/defaultLandingPage';
import { dashboardListSelector } from '@store/tempDashboard/selectors';

import Prompt from './Prompt';

const selector = createSelector(
  commonSelector,
  tabsStoreSelector,
  dashboardsUIStoreSelector,
  defaultLandingPageStore,
  dashboardListSelector,
  (common, tabsStore, dashboardsUIStore, defaultLandingPage, dashboards) => ({
    tabsStore,
    dashboardsUIStore,
    appliedFilters: common.appliedFilters,
    defaultLandingPageConfig: defaultLandingPage,
    visible: defaultLandingPage.showPrompt,
    title: defaultLandingPage.promptTitle,
    content: defaultLandingPage.promptContent,
    needInput: defaultLandingPage.promptNeedInput,
    onOkFn: defaultLandingPage.promptOkFn,
    dashboards,
  }),
);

export default connect(selector, {
  createDashboard: createActions.createDashboard,
  updateDashboard: updateActions.updateDashboard,
  showPrompt,
  hidePrompt,
  createDashboardByDashboardType: createActions.createDashboardByDashboardType,
})(Prompt);
